import styled from 'styled-components';
import { Layout } from 'antd';

export const HeaderContainer = styled(Layout.Header)`
  box-sizing: border-box;
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 16px 32px;
  gap: 24px;
  background: ${({ theme }) => `${theme.colorBgBase}`};
  border-bottom: 1px solid ${({ theme }) => theme.layoutBorderColor};
`;
